export const contentfulImageUrl = (url: string) => {
  if (url.endsWith('.svg')) return url;
  return url + '?fm=webp&q=80';
};
